module.exports = __webpack_public_path__ + "static/media/announceIcon.9c028308.svg";